import { createContext } from "react";
import PropTypes from "prop-types";

export const LocalizationContext = createContext({
  language: "",
  translations: {},
});

export const LocalizationContextProvider = ({ language, translations, children }) => (
  <LocalizationContext.Provider
    value={{
      language,
      translations,
    }}
  >
    {children}
  </LocalizationContext.Provider>
);

LocalizationContextProvider.propTypes = {
  language: PropTypes.string,
  translations: PropTypes.objectOf(PropTypes.string),
  children: PropTypes.node.isRequired,
};

LocalizationContextProvider.defaultProps = {
  language: "en",
  translations: {},
};
